'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuyCenter = /** @class */function () {
    function BuyCenter() {
        this.buyCenterDom = document.getElementById("kingshiper-buycenter-container");
        this.pathName = decodeURIComponent(window.location.pathname);
        if (this.pathName === '/store' || this.pathName.includes('/store/list_')) {
            // 全部
            this.tabFlag = 'all';
        } else {
            // 单独的分类
            if (this.pathName.includes('/list_')) {
                this.tabFlag = this.pathName.match(/store\/(\S*)\/list_/)[1];
            } else {
                this.tabFlag = this.pathName.match(/store\/(\S*)/)[1];
            }
        }
        this.currentPage = webInfo.current_page;
        this.pageSize = webInfo.per_page;
        this.dataTotal = webInfo.total;
        this.pageTotal = webInfo.last_page;
        this.init();
    }
    BuyCenter.prototype.init = function () {
        this.defaultEvent();
        this.logic();
    };
    BuyCenter.prototype.logic = function () {
        var _this = this;
        var that = this;
        this.tabFlag = this.tabFlag.toLocaleLowerCase();
        if (this.tabFlag == 'all' || this.tabFlag == 'bucket') {
            var activeShowBox = _tool2.default.$_select(that.buyCenterDom, ".show-all-box");
            var activeTab = _tool2.default.$_select(that.buyCenterDom, ".kingshiper-buycenter-container-item .".concat(this.tabFlag));
            var activeContent = _tool2.default.$_select(that.buyCenterDom, ".show-all-box .product-content");
            activeShowBox.classList.add('active');
            activeTab.classList.add('active');
            activeContent.classList.add('active');
            var navItems = _tool2.default.$_selectAll(that.buyCenterDom, '.kingshiper-buycenter-container-left p .product-type');
            navItems.forEach(function (item) {
                var dataAlias = item.getAttribute('data-alias');
                if (dataAlias.toLocaleLowerCase() == _this.tabFlag) {
                    item.classList.add('active');
                }
            });
        } else {
            var activeShowBox = _tool2.default.$_select(that.buyCenterDom, ".show-category-box");
            var activeContent = _tool2.default.$_select(that.buyCenterDom, ".show-category-box .product-content");
            activeShowBox.classList.add('active');
            activeContent.classList.add('active');
            var navItems = _tool2.default.$_selectAll(that.buyCenterDom, '.kingshiper-buycenter-container-left .nav-item');
            navItems.forEach(function (item) {
                var dataAlias = item.getAttribute('data-alias');
                if (dataAlias.toLocaleLowerCase() == _this.tabFlag) {
                    item.classList.add('active');
                }
            });
        }
        try {
            var paginationId = '';
            if (this.tabFlag == 'all' || this.tabFlag == 'bucket') {
                paginationId = '#pagination-all';
            } else {
                paginationId = '#pagination1';
            }
            new Pagination({
                element: paginationId,
                type: 2,
                layout: 'prev, pager, next, jumper',
                pageIndex: that.currentPage,
                pageSize: that.pageSize,
                pageCount: 5,
                total: that.dataTotal,
                singlePageHide: true,
                ellipsis: true,
                disabled: true,
                currentChange: function currentChange(index) {
                    if (index == 1) {
                        if (that.tabFlag === 'all') {
                            window.location.href = "/store";
                        } else {
                            window.location.href = "/store/".concat(that.tabFlag);
                        }
                    } else {
                        if (that.tabFlag === 'all') {
                            window.location.href = "/store/list_".concat(index, ".html");
                        } else {
                            window.location.href = "/store/".concat(that.tabFlag, "/list_").concat(index, ".html");
                        }
                    }
                }
            });
        } catch (e) {
            console.log(e);
        }
    };
    BuyCenter.prototype.defaultEvent = function () {
        var that = this;
        // 左侧固定(待优化)
        var leftNav = _tool2.default.$_select(that.buyCenterDom, ".kingshiper-buycenter-container-left");
        var activeShowCategoryBox = _tool2.default.$_select(that.buyCenterDom, ".show-category-box");
        var activeShowAllBox = _tool2.default.$_select(that.buyCenterDom, ".show-all-box");
        var boundaryHeight;
        window.onload = function () {
            var bodyHeight = document.body.clientHeight;
            var navHeight = _tool2.default.$_select(that.buyCenterDom, ".kingshiper-buycenter-container-left").clientHeight;
            boundaryHeight = bodyHeight - 420 - navHeight;
        };
        document.addEventListener('scroll', function () {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 406 && scrollTop < boundaryHeight) {
                leftNav.style.position = "fixed";
                leftNav.style.top = "92px";
                leftNav.style.zIndex = "99";
                activeShowCategoryBox.style.marginLeft = "268px";
                activeShowAllBox.style.marginLeft = "268px";
            } else {
                leftNav.style.position = "static";
                activeShowCategoryBox.style.marginLeft = "0px";
                activeShowAllBox.style.marginLeft = "0px";
            }
        });
    };
    return BuyCenter;
}();
exports.default = BuyCenter;